import getLocalApiAxiosClient from './localApiAxiosClient';

const hybrisAxiosClient = getLocalApiAxiosClient({
    baseURL: '/api/hybris',
});

export default hybrisAxiosClient;
